import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, Form } from 'redux-form';
import { Button, Card, CardBody, FormGroup, Label, Row, Col } from 'reactstrap';
import { connect } from 'react-redux';
import Box from '@material-ui/core/Box';
import FaClose from 'react-icons/lib/fa/close';
import LocationMultiSelect from '../ReduxForm/LocationMultiSelect';
import { exportDataRequest } from  './hooks';
import DatePickerWithLabel from '../ReduxForm/DatePickerWithLabel';
import LoadingButton from '../Helpers/LoadingButton';
import { loadingErrorSelector } from '../../Redux/loading/selectors';
import { SaveErrorPropType } from '../../proptypes/errors';
import { loadingIsLoadingSelector } from '../../Redux/loading/selectors';
import { setLoading } from '../../Redux/loading/actions';

const EXPORT_TYPE = 'franchise_partner_accounting_datev';
const FORM_KEY = 'franchise_partner_accounting_export_datev';

const FranchisePartnerAccountingExport_Datev = ({ handleSubmit, reset, saveError, isLoading, formValues }) => {

    return  (
        <Box mt={3}>
            <Card data-cy="card-franchise_partner_accounting_export_datev">
                <h6 className="card-header">Franchisepartnerabrechnungen-DATEV-Datei</h6>
                <CardBody>
                    <p>
                        Unter folgendem Link kann die Datei für die Franchisepartnerabrechnungen heruntergeladen
                        werden. (Zum Import in die DATEV-Datenbank)
                    </p>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Field
                                        label="Zeitraum vom:"
                                        name="dateFrom"
                                        component={DatePickerWithLabel}
                                        saveError={saveError}
                                    />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Field
                                        label="bis:"
                                        name="dateTill"
                                        component={DatePickerWithLabel}
                                        saveError={saveError}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label>Standort:</Label>
                                    <Field name="location_id" component={LocationMultiSelect} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className="text-center">
                                <Button
                                    type="button"
                                    color="primary"
                                    onClick={reset}
                                    title="Alle Einstellungen zurücksetzen"
                                    data-cy="reset"
                                >
                                    <FaClose />
                                    &nbsp;Zurücksetzen
                                </Button>{' '}
                                <LoadingButton
                                    color="primary"
                                    id={FORM_KEY}
                                    title="Klicken um die Datei herunterzuladen"
                                    type="submit"
                                    isLoading={isLoading}
                                >
                                    Herunterladen
                                </LoadingButton>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </CardBody>
            </Card>
        </Box>
    )
};

FranchisePartnerAccountingExport_Datev.propTypes = {
    saveError: SaveErrorPropType,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    formValues: PropTypes.object.isRequired, 
};

FranchisePartnerAccountingExport_Datev.defaultProps = {
    saveError: null,
};

export default connect(
    (state) => ({
        saveError: loadingErrorSelector(state, FORM_KEY),
        isLoading: loadingIsLoadingSelector(state, FORM_KEY),
        formValues: state.form[FORM_KEY]?.values || {}, 
    }),
    (dispatch) => ({
        onSubmit: async (values) => {
            dispatch(setLoading(true, FORM_KEY));
            try {
                await exportDataRequest(EXPORT_TYPE, values);
            } finally {
                dispatch(setLoading(false, FORM_KEY));
            }
        },
    })
)(reduxForm({ form: FORM_KEY })(FranchisePartnerAccountingExport_Datev));

